module.exports = __webpack_public_path__ + "static/img/response4.55956e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/response4.png
// module id = S4MD
// module chunks = 0